import * as yup from 'yup';
const stringValid = yup.string().required('Este campo es requerido');

export const loginSchema = yup.object().shape({
  email: stringValid
    .required('Este campo es requerido')
    .email('Ingrese un correo válido'),
  password: stringValid,
});
